export const SIGNUP_USER = "signup_user"
export const SIGNUP_USER_SUCCESS = "signup_user_success"
export const SIGNUP_USER_FAIL = "signup_user_fail"

export const LOGIN_USER = "login_user"
export const LOGIN_USER_SUCCESS = "login_user_success"
export const LOGIN_USER_FAIL = "login_user_fail"

export const INVALIDATE_DATA = "invalidate_data"

export const ADD_FLASH_MESSAGE = "add_flash_message"
export const DELETE_FLASH_MESSAGE = "delete_flash_message"

export const SET_CURRENT_USER = "set_current_user"

export const UPDATE_SETTINGS = "update_settings"



// WEBPACK FOOTER //
// ./src/actions/types.js